import styled from "styled-components";
import {NavLink} from "react-router-dom";
import {FormControl} from "@mui/material";
import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import {getLogo} from "modules/utils";
import logo from "assets/images/icons/logo.png";

export const FormWrapper = styled.div`
	flex-grow: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	background-size: cover;
	background: url(${({theme}) => theme.background.bgImage}) #1c1c1c;
	padding: 100px 0;
`;

export const Form = styled.form`
	width: 100%;
	padding: 30px 40px;
	border-radius: 4px;
	box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%),
		0px 1px 3px 0px rgb(0 0 0 / 12%);
	background: ${({theme}) => theme.background.form};
	color: ${({theme}) => theme.color.tertiary};

	@media (min-width: 769px) {
		max-width: 600px;
	}
`;

export const FormContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	max-width: 320px;
	margin: 0 auto;
`;

export const FormTitle = styled.h2`
	text-align: center;
	font-size: 20px;
	font-weight: 700;
	font-family: "Khand", sans-serif;
	margin-bottom: 20px;
`;

export const FormSubTitle = styled.h2`
	font-family: "Hind", sans-serif;
	text-align: center;
	font-size: 16px;
	font-weight: 500;
	margin-bottom: 28px;
`;

export const FormIcon = styled.img`
	width: 125px;
	margin-bottom: 24px;
	margin-top: 24px;

	&.small {
		width: 50px;
		height: 50px;
	}
`;

FormIcon.defaultProps = {
	src: logo,
};

export const FormLogo: FC<React.ImgHTMLAttributes<HTMLImageElement>> = (props) => {
	const {i18n} = useTranslation();
	const logo = getLogo(i18n.language);

	return <FormIcon src={logo} {...props} />;
};

export const FormLink = styled(NavLink)`
	font-family: "Hind", sans-serif;
	color: ${({theme}) => theme.background.active};
	text-align: right;
	letter-spacing: 0.02em;
	font-size: 14px;

	&.center {
		text-align: center;
	}

	span.black {
		color: ${({theme}) => theme.color.primary};
	}

	span.white {
		color: ${({theme}) => theme.color.tertiary};
	}
`;

export const PageFormPaper = styled.div`
	width: 100%;
	background: ${({theme}) => theme.background.form};
	color: ${({theme}) => theme.color.tertiary};
	box-shadow: 0 0.1px 0.3px rgba(28, 28, 30, 0.1), 0 1px 2px rgba(28, 28, 30, 0.2);
	border-radius: 4px;
	font-family: "Hind", sans-serif;
	padding: 20px;
`;

export const PageFormTitle = styled.div`
	font-size: 16px;
	line-height: 20px;
	font-weight: 500;

	&.mb-5 {
		margin-bottom: 5px;
	}
`;

export const PageFormText = styled.div`
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.02em;

	button {
		font-size: 14px;
	}
`;

export const PageFormField = styled(FormControl)`
	&.MuiFormControl-root {
		width: 100%;
		margin-bottom: 20px;

		label {
			&[data-shrink="false"] {
				top: -2px;
			}
		}
	}
`;
